import { Group } from '@visx/group';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ShapeCircle(_ref) {
  let {
    fill,
    width,
    height,
    style
  } = _ref;
  const cleanWidth = typeof width === 'string' || typeof width === 'undefined' ? 0 : width;
  const cleanHeight = typeof height === 'string' || typeof height === 'undefined' ? 0 : height;
  const size = Math.max(cleanWidth, cleanHeight);
  const radius = size / 2;
  return /*#__PURE__*/_jsx("svg", {
    width: size,
    height: size,
    children: /*#__PURE__*/_jsx(Group, {
      top: radius,
      left: radius,
      children: /*#__PURE__*/_jsx("circle", {
        r: radius,
        fill: fill,
        style: style
      })
    })
  });
}